import './MultigamesPage.css';
import { useState } from 'react';
import Header from '../components/Header';
import usePageTracker from "../hooks/usePageTracker.js";

import VerbDash from '../minigames/VerbDash';
import PiensaRapido from '../minigames/PiensaRapido';
import TraduceOracion from '../minigames/TraduceOracion';
import Basta from '../minigames/Basta';
import NounsInvasion from '../minigames/NounsInvasion';
import AdjectiveLadder from '../minigames/AdjectiveLadder';
import MeaningMatch from '../minigames/MeaningMatch';
import TimeTraveler from '../minigames/TimeTraveler';
import WhereIsIt from '../minigames/WhereIsIt';
import Describing from '../minigames/Describing';
import StudentGame from '../minigames/StudentGame';

const gamesMap = {
    neura_cinema: { Component: StudentGame, icon: '🎬', name: 'NeuraCinema', color: '#7c3aed' },
    verb_dash: { Component: VerbDash, icon: '🏃‍♂️', name: 'Verb Dash', color: '#00FFFF' },
    piensa_rapido: { Component: PiensaRapido, icon: '⚡️', name: 'Piensa Rápido', color: '#FFFF00' },
    traduce_oracion: { Component: TraduceOracion, icon: '🔄', name: 'Traduce la Oración', color: '#9D00FF' },
    basta: { Component: Basta, icon: '🛑', name: 'Basta', color: '#39FF14' },
    plural_invasion: { Component: NounsInvasion, icon: '👽', name: 'Nouns Invasion', color: '#00FFFF' },
    adjective_ladder: { Component: AdjectiveLadder, icon: '🪜', name: 'Adjective Ladder', color: '#FF7700' },
    meaning_match: { Component: MeaningMatch, icon: '🔗', name: 'Meaning Match', color: '#00F5D4' },
    time_traveler: { Component: TimeTraveler, icon: '⏳', name: 'Time Traveler', color: '#39FF14' },
    where_is_it: { Component: WhereIsIt, icon: '📍', name: 'Where Is It?', color: '#0F52BA' },
    caricaturas: { Component: Describing, icon: '🎨', name: 'Describing', color: '#D946EF' },

};

const gameList = Object.keys(gamesMap);

function MultigamesPage() {
    usePageTracker("games", "Minijuegos", null, "playing");
    const [activeGameKey, setActiveGameKey] = useState(gameList[0]);

    const ActiveGameInfo = gamesMap[activeGameKey];
    const ActiveComponent = ActiveGameInfo.Component;

    return (
        <div>
            <Header />
            <div className="mg-page-container">

                <nav className="mg-navbar">
                    <ul className="mg-games-list">
                        {gameList.map((gameKey) => {
                            const game = gamesMap[gameKey];
                            return (
                                <li
                                    key={gameKey}
                                    className={`mg-game-item ${gameKey === activeGameKey ? 'active' : ''}`}
                                    onClick={() => setActiveGameKey(gameKey)}
                                    style={gameKey === activeGameKey ? { '--active-game-color': game.color } : {}}
                                >
                                    <span className="mg-game-icon">{game.icon || '⭐'}</span>
                                    <div className="mg-game-title">{game.name || 'Juego'}</div>
                                </li>
                            );
                        })}
                    </ul>
                </nav>

                <div className="mg-mobile-nav">
                    <div className="mg-mobile-nav-grid">
                        {gameList.map((gameKey) => {
                            const game = gamesMap[gameKey];
                            return (
                                <button
                                    key={`mobile-${gameKey}`}
                                    className={`mg-mobile-nav-item ${gameKey === activeGameKey ? 'active' : ''}`}
                                    onClick={() => setActiveGameKey(gameKey)}
                                    style={gameKey === activeGameKey ? { '--active-game-color': game.color } : {}}
                                >
                                    {game.icon || '⭐'}
                                </button>
                            );
                        })}
                        <div className="mg-mobile-nav-label-wrapper">
                            <p className="mg-mobile-nav-label">
                                {ActiveGameInfo.name || 'Juego'}
                            </p>
                        </div>
                    </div>
                </div>

                <main className="mg-game-main-content">
                    {ActiveComponent ? (
                        <ActiveComponent gameData={ActiveGameInfo} token={localStorage.getItem('token')} />
                    ) : (
                        <div className="mg-placeholder-card">
                            <div className="mg-placeholder-header">
                                <span className="mg-placeholder-icon">{ActiveGameInfo.icon}</span>
                                <h2 className="mg-placeholder-title">{ActiveGameInfo.name}</h2>
                            </div>
                            <p>¡Este juego estará disponible próximamente!</p>
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
}

export default MultigamesPage;